// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"72595":"7aed538dd8691fee","85645":"f7a3f074ccfc463c"}[chunkId] + ".css";
};